import React, { useState } from "react";

export const Contact = () => {
  const [formData, setFormData] = useState({
    subject: "",
    body: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailtoLink = `mailto:cheatsheetai@gmail.com?subject=${encodeURIComponent(
      formData.subject
    )}&body=${encodeURIComponent(formData.body)}`;
    window.location.href = mailtoLink;
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="section-title">
            <h2>Contact</h2>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="subject"
                className="form-control"
                placeholder="Subject"
                required
                value={formData.subject}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <textarea
                name="body"
                className="form-control"
                rows="5"
                placeholder="Message"
                required
                value={formData.body}
                onChange={handleChange}
              ></textarea>
            </div>
            <button type="submit" className="btn btn-custom btn-lg">
              Send Message
            </button>
          </form>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Cheat Sheet AI{" "}
            
          </p>
        </div>
      </div>
    </div>
  );
};
